import useFullUrl from "web/core/shop/useFullUrl";
import { useCallback } from "react";
import { useHistory } from "react-router";

const useSearchBarNavigation = (search) => {
  const history = useHistory();

  const searchUrl = `/search/${encodeURIComponent(search?.search)}`;
  const searchTarget = useFullUrl(`/search/{search}`);

  const onSubmit = useCallback(
    ({ search }) => {
      if (search && search.length > 0) {
        history.push("/search/" + encodeURIComponent(search));
      }
    },
    [history]
  );

  return { searchUrl, searchTarget, onSubmit };
};

export default useSearchBarNavigation;
